module.exports = __webpack_public_path__ + "static/media/settings.53985e60.svg";